/* scroll-up-bar v0.3.0 (https://github.com/eduardomb/scroll-up-bar) */
( function( $ ) {
    'use strict';

    var _destroyFn;

    $.scrollupbar = function( $bar, options ) {
        // Default options
        options = $.extend( {
            enterViewport: $.noop,
            fullyEnterViewport: $.noop,
            exitViewport: $.noop,
            partiallyExitViewport: $.noop,
            hitTop: $.noop,
        }, options );

        function isFullyInViewport() {
            return $window.scrollTop() <= $bar.offset().top;
        }

        function isInViewport() {
            return $window.scrollTop() < $bar.offset().top + $bar.outerHeight();
        }

        function isTopOfPage() {
            return $window.scrollTop() === 0;
        }

        var $window = $( window ),
            $document = $( document ),
            minY = $bar.css( 'position' ) == 'fixed' ? 0 : $bar.offset().top,
            lastY = $window.scrollTop(), // Use last Y to detect scroll direction.
            initialPosTop = $bar.position().top,
            timeout;

        $.scrollupbar.isInViewport = isInViewport();
        $.scrollupbar.isFullyInViewport = isFullyInViewport();
        $.scrollupbar.isTopOfPage = isTopOfPage();

        $window.on( 'scroll.scrollupbar', function() {
            var y = $window.scrollTop(),
                barHeight = $bar.outerHeight();

            // Ignore elastic scrolling.
            if ( y < 0 || y > ( $document.height() - $window.height() ) ) {
                return;
            }

            // Cancel the event fired by the previous scroll.
            if ( timeout ) {
                clearTimeout( timeout );
            }

            if ( isTopOfPage() ) {
                options.hitTop();
            }

            if ( y < lastY ) { // Scrolling up
                // If the bar is hidden, place it right above the top frame.
                if ( !$.scrollupbar.isInViewport && lastY - barHeight >= minY ) {
                    $bar.css( 'top', lastY - barHeight );
                    $.scrollupbar.isInViewport = true;
                    options.enterViewport();
                }

                // Scrolls up bigger than the bar's height fixes the bar on top.
                if ( isFullyInViewport() ) {
                    if ( y >= minY ) {
                        $bar.css( {
                            'position': 'fixed',
                            'top': 0,
                        } );
                    } else {
                        $bar.css( {
                            'position': 'absolute',
                            'top': initialPosTop,
                        } );
                    }

                    if ( !$.scrollupbar.isFullyInViewport ) {
                        $.scrollupbar.isFullyInViewport = true;
                        options.fullyEnterViewport();
                    }
                }

                // Fire an event to reveal the entire bar after 400ms if the scroll
                // wasn't big enough.
                timeout = setTimeout( function() {
                    if ( !$.scrollupbar.isFullyInViewport ) {
                        $bar.css( {
                            'position': 'fixed',
                            'top': $bar.offset().top - y,
                        } );

                        $bar.animate( { 'top': 0 }, 100, function() {
                            $.scrollupbar.isFullyInViewport = true;
                            options.fullyEnterViewport();
                        } );
                    }
                }, 400 );
            } else if ( y > lastY ) { // Scrolling down
                // Unfix the bar allowing it to scroll with the page.
                if ( $.scrollupbar.isFullyInViewport ) {
                    $bar.css( {
                        // translate3d fixes iOS invisible element bug when changing
                        // position values while scrolling.
                        'transform': 'translate3d(0, 0, 0)',
                        'position': 'absolute',
                        'top': lastY > minY ? lastY : initialPosTop,
                    } );

                    if ( !isFullyInViewport() ) {
                        $.scrollupbar.isFullyInViewport = false;
                        options.partiallyExitViewport();
                    }
                }

                if ( $.scrollupbar.isInViewport && !isInViewport() ) {
                    $.scrollupbar.isInViewport = false;
                    options.exitViewport();
                }

                // Fire an event to hide the entire bar after 400ms if the scroll
                // wasn't big enough.
                timeout = setTimeout( function() {
                    if ( isInViewport() && y - barHeight >= minY ) {
                        $bar.animate( { 'top': y - barHeight }, 100, function() {
                            $.scrollupbar.isInViewport = false;
                            options.exitViewport();
                        } );
                    }
                }, 400 );
            }

            lastY = y;
        } );

        _destroyFn = function() {
            // Unbind all listeners added by scrollupbar plugin
            $window.off( '.scrollupbar' );

            // Restore original bar position.
            $bar.css( {
                'position': 'absolute',
                'top': initialPosTop,
            } );
        };

        return $bar;
    };

    $.scrollupbar.destroy = function() {
        if ( _destroyFn ) {
            return _destroyFn();
        }
    };

    $.fn.scrollupbar = function( options ) {
        return $.scrollupbar( this, options );
    };
} )( jQuery );


( function( window, document, $ ) {
    'use strict';

    // --------------------------------------------------
    // EVENTS
    // --------------------------------------------------
    $( window ).on( 'load', function() {
        // Add 'window load' logic here.
    } );

    $( document ).ready( function() {
        // Notification bar
        const notification = $( '.js--notification-bar' );
        const notificationClose = notification.find( '.js--close-button' );
        notificationClose.on( 'click', function( e ) {
            e.preventDefault();
            e.stopPropagation();
            notification.fadeOut().remove();
        } );
        document.styleSheets[ 0 ].insertRule( '.notification-bar + .header {top: ' + notification.outerHeight() + 'px !important}' );

        const siteHeader = $( '.js--header' );
        if ( siteHeader.css( 'position' ) == 'absolute' ) {
            // Only if css is enabled, for accessibility
            siteHeader.scrollupbar( {
                enterViewport: function() {
                    siteHeader.addClass( 'is-fixed' );
                },
                hitTop: function() {
                    siteHeader.removeClass( 'is-fixed' );
                },
            } );
        }

    } );

    $( window ).on( 'scroll', scrollEventHandler );

    $( window ).on( 'resize', resizeEventHandler );

    $( '.filter-dropdown' ).on( 'change', filterChangeHandler );


    // --------------------------------------------------
    // DECLARE FUNCTIONS
    // --------------------------------------------------
    /**
    * Wrapper around *any* logic which should be triggered on window scroll.
    */
    function scrollEventHandler( e ) {
        // Add 'window scroll' logic here.
    }

    /**
    * Wrapper around *any* logic which should be triggered on window resize.
    */
    function resizeEventHandler( e ) {
        // Add 'window resize' logic here.
    }

    /**
    * Wrapper around *any* logic for filter dropdowns.
    */
    function filterChangeHandler( e ) {
        let dropdown = e.target;

        switch( dropdown.id ) {

        case 'event-date-filter': {
            let dateBlocks = Array.from( document.getElementsByClassName( 'list-block--archive-events' ) );
            dateBlocks.map( ( block ) => {
                block.style.display = ! dropdown.value || dropdown.value == block.id ? 'block' : 'none';
            } );
            break;
        }
        case 'event-type-filter': {
            let events = Array.from( document.getElementsByClassName( 'list-block-item--archive-events' ) );
            events.map( ( event ) => {
                event.style.display = ! dropdown.value || $( event ).hasClass( 'event-type-' + dropdown.value ) ? 'block' : 'none';
            } );
            break;
        }

        }
    }

} )( window, document, jQuery );
